import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAtom } from 'jotai';
import { useAtomValue, useResetAtom, useUpdateAtom } from 'jotai/utils';
import {
  openFilterAtom,
  filtersAtom,
  filtersResetAtom,
  filtersInitialState
} from 'global/store';
import useCustomFilterOptions from 'hooks/products/useCustomFilterOptions';
import { Box } from '@xstyled/styled-components';
import CategoryFilter from './Attributes/Category';
import PriceFilter from './Attributes/Price';
import CustomAttributeFilter from './Attributes/CustomAttribute';
import Button from '@/UI/Button';
import { CategoryTitle } from '@/UI/Primitives/Headings';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { Close } from '@/UI/Icons';

export default function FilterSidebar({ ...props }) {
  const router = useRouter();

  // Mobile filter
  const [isFilterOpen, setOpen] = useAtom(openFilterAtom);

  // Get custom attribute filter options
  const aggregations = useCustomFilterOptions();

  const filters = useAtomValue(filtersAtom);

  const reset = useResetAtom(filtersAtom);
  const setFiltersReset = useUpdateAtom(filtersResetAtom);

  const resetFilters = () => {
    reset();
    setFiltersReset(true);
  };

  useEffect(() => {
    const handleRouteChange = url => {
      // let sliceSourceTarget =
      //   router.asPath.indexOf('?') === -1 ? 0 : router.asPath.indexOf('?');

      // let sourcePath = router.asPath.slice(
      //   10,
      //   sliceSourceTarget ? sliceSourceTarget : router.asPath.length
      // );

      let sliceTargetTarget;
      if (url.includes('?')) {
        return (sliceTargetTarget =
          url.indexOf('?') === -1 ? 0 : url.indexOf('?'));
      } else {
        sliceTargetTarget = url.length;
      }

      let targetPath = url.slice(10, sliceTargetTarget);

      if (router.asPath !== targetPath) {
        return resetFilters();
      }
      resetFilters();
      isFilterOpen && setOpen(false);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => router.events.off('routeChangeComplete', handleRouteChange);
  }, []);

  return (
    <FlexBox dir="column" minW={245} mt={{ _: 64, desktop: 48 }} {...props}>
      {/* Remove filters */}
      {filters !== filtersInitialState && (
        <Button
          display="inline-flex"
          pb="1rem"
          pl={0}
          onClick={() => resetFilters()}
        >
          <CategoryTitle fontSize="xsmall">Eemalda filtrid</CategoryTitle>
          <Box
            as="span"
            role="img"
            aria-label="Clear filters"
            hoverOpacity={0.8}
            transform="translateX(25%) translateY(-12%)"
          >
            <Close bg="transparent" stroke="#45AAC4" />
          </Box>
        </Button>
      )}

      {/* Category */}
      <CategoryFilter />

      {/* Price */}
      {aggregations && <PriceFilter />}

      {/* Other custom attributes */}
      {aggregations?.slice(2).map(item => {
        if (item.attribute_code !== 'kuva_avalehel') {
          const options = item.options
            .filter(({ label }) => label !== '-')
            .map(({ label, value }) => {
              return {
                name: label,
                label,
                value
              };
            });
          return (
            <CustomAttributeFilter
              key={item.label}
              title={item.label.toUpperCase()}
              attribute={item.attribute_code}
              options={options}
            />
          );
        }
      })}
    </FlexBox>
  );
}
